import React, {useEffect, useState} from "react";
import config from "../../config";
import RestRequest from "../../tool/RestRequest";
import AddWishListThemeLine from "./theme/line";
import AddWishListThemeDefault from "./theme/default";
import FavoriteService from "../../service/FavoriteService";

export default function AddWishlistInList({product_id, isExist = false, theme = 'default'}) {

    const [isEx, setIsEx] = useState(false);

    useEffect(() => {

        RestRequest.one(config.restFavorite, product_id)
            .then(data => {
                setIsEx(data.data.isExist);
            });

    }, []);

    function add2favorite(productId) {

        FavoriteService.add(productId).then(data => {

            if (data.status === 200) {
                FavoriteService.updateCounter();
            }

            setIsEx(!isEx);
        });
    }

    function remove() {

        RestRequest.delete(config.restFavorite, product_id).then(data => {

            if (data.status === 200) {
                FavoriteService.updateCounter(true);
            }

            setIsEx(!isEx);
        });
    }


    function handleClick(event) {
        add2favorite(product_id)
    }


    const params = {
        states: {
            isEx: isEx,
        },
        actions: {
            setIsEx: setIsEx,
            add2wish: add2favorite,
            handleClick: handleClick,
            remove: remove,
        },
    };

    switch (theme) {
        case 'line':
            return <AddWishListThemeLine params={params}/>;
        default:
            return <AddWishListThemeDefault params={params}/>;
    }
}